import gameAssets from '@themed-assets';
import styles from './PlayerBackCards.module.css'
import { TEXAS_HOLDEM, OMAHA, OMAHA5, OMAHA6 } from '@/Poker/data/Constants';
import { AnimatePresence, motion } from 'motion/react';

export default function PlayerBackCards({ maxPlayers, clientChairIndex, gameDefinition, playerSeat, position, isSeatedOut, isInactive, isGameStarted, isFolded, revealCard, gameId }) {

	const getPositionClass = () => {
		// Generic logic for other player counts
		const halfPoint = Math.floor(maxPlayers / 2);
		if (clientChairIndex === 0) return styles.bottom;
		if (clientChairIndex < halfPoint) return styles.left;
		if (clientChairIndex === halfPoint) return styles.top;
		return styles.right;
	};

	const returnNumberOfCards = () => {
		switch (gameDefinition.gameType) {
			case TEXAS_HOLDEM:
				return 2;
			case OMAHA:
				return 4;
			case OMAHA5:
				return 5;
			case OMAHA6:
				return 6;
		}
	}

	const returnCardMargin = () => {
		switch (gameDefinition.gameType) {
			case TEXAS_HOLDEM:
				return -10;
			default:
				return -15;
		}
	}

	const getCardDelay = (index) => {
		return gameDefinition.gameType === TEXAS_HOLDEM ? index * 0.5 : index * 0.25;
	}

	return (
		<AnimatePresence>
			{
				isGameStarted && !isSeatedOut && !isInactive && playerSeat !== position && !isFolded && !revealCard ?
					<motion.div
						// Keep exit animation for when cards disappear, but avoid container-level entrance animation
						exit={{
							y: [0, -5, 15],
							scale: [1, 1.05, 1, 0]
						}}
						className={`${styles.playerBackCards} ${getPositionClass()}`}>
						{
							Array.from({ length: returnNumberOfCards() }).map((_, index) => (
								<motion.img
									key={index + 'playerBackCard' + gameId}
									src={gameAssets.cardback}
									alt="card back"
									className={styles.cardBackIcon}
									style={{ marginLeft: index === 0 ? 0 : `${returnCardMargin()}px` }}
									initial={{ opacity: 0, y: 30, scale: 0.9 }}
									animate={{ opacity: 1, y: 0, scale: 1 }}
									transition={{ delay: getCardDelay(index), type: 'spring', stiffness: 500, damping: 30 }}
								/>
							))
						}
					</motion.div>
					: null
			}
		</AnimatePresence>
	)
}
